module.exports = __webpack_public_path__ + "Roboto-Bold-webfont.73d4f283372338742066.svg";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Bold-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Bold-webfont.svg
// module chunks = 2